import React from "react";
import { Navigate, useLocation } from "react-router";
import { LOGIN_ROUTE } from "Constants";
import { useIsAuthenticated } from "Hooks";

const RequireAuth = ({
  children,
}: {
  children: React.ReactNode;
}): React.JSX.Element | null => {
  const auth = useIsAuthenticated();
  const location = useLocation();

  if (!auth.isInitialized) {
    return null;
  }

  if (!auth.isAuthenticated) {
    // Redirect them to the /login page, but save the current location they were
    // trying to go to when they were redirected. This allows us to send them
    // along to that page after they login, which is a nicer user experience
    // than dropping them off on the home page.
    return (
      <Navigate to={`${LOGIN_ROUTE}`} state={{ from: location }} replace />
    );
  }

  return <>{children}</>;
};

export default RequireAuth;
